module.exports = fox._r("css/slick/fonts/slick.svg", __webpack_public_path__ + "_/_/_/main/css/slick/fonts/slick.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/css/slick/fonts/slick.svg
// module id = 117
// module chunks = 4